import { CALL_API } from '../libraries/middleware';
import actionCreator from '../libraries/actionCreator';

interface BindingObject {
    storeId: number;
    deviceId: number;
    serialNumber: string;
    mac: string;
    model: string;
    name: string;
    no: string;
    invoiceAmount: number;
    extra: string;
}

interface TaiwanPayKey {
    storeId: number;
    merchantId: string;
    terminalId: string;
}

export const { Actions, Constants } = actionCreator({
    getPaymentMethod() {
        return {
            [CALL_API]: {
                method: 'GET',
                path: '/payment/method'
            }
        }
    },

    addChangeDeviceAccessory(formData: object) {
        return {
            [CALL_API]: {
                method: 'POST',
                path: '/device/portal/accessory',
                body: formData
            }
        }
    },

    deleteDeviceAccessory(formData: object) {
        return {
            [CALL_API]: {
                method: 'DELETE',
                path: '/device/portal/accessory',
                body: formData
            }
        }
    },

    deleteDevice(deviceId: number) {
        return {
            [CALL_API]: {
                method: 'DELETE',
                path: `/device/${deviceId}`,
            }
        }
    },

    deviceBinding(formData: BindingObject) {
        const { storeId, serialNumber, mac, model, name, no, invoiceAmount, extra } = formData;
        return {
            [CALL_API]: {
                method: 'POST',
                path: `/store/${storeId}/bind`,
                body: {
                    sn: serialNumber,
                    mac: mac,
                    model: model,
                    name: name,
                    no: no,
                    invoiceAmount: invoiceAmount,
                    extra: extra
                }
            }
        }
    },

    deviceEdit(formData: BindingObject) {
        const { deviceId, serialNumber, mac, name, no, invoiceAmount, extra } = formData;
        return {
            [CALL_API]: {
                method: 'PUT',
                path: `/device/${deviceId}`,
                body: {
                    serialNumber: serialNumber,  
                    mac: mac,
                    displayName: name,
                    no: no,
                    invoiceAmount: invoiceAmount,
                    extra: extra
                }
            }
        }
    },

    getMaDeviceByDevice(deviceId: number) {
        return {
            [CALL_API]: {
                method: 'GET',
                path: `/device/${deviceId}/ma`,
            }
        }
    },

    getTaiwanPayKey(taiwanPayKey: TaiwanPayKey) {
        const { storeId, merchantId, terminalId } = taiwanPayKey;
        return {
            [CALL_API]: {
                method: 'POST',
                path: `/store/${storeId}/taiwan-pay/key`,
                body: {
                    merchantId: merchantId,
                    terminalId: terminalId,
                }
            }
        }
    },

    getDeviceByStoreId(storeId: number) {
        return {
            [CALL_API]: {
                method: 'GET',
                path: `/device/store/${storeId}`,
            }
        }
    }
});
